import React from 'react';
import { AdvertisingMetric } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/AdvertisingConstants';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';

import ProductGrid from 'src/components/BeaconV2Components/ProductGrid/ProductGrid';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';
import { useAppSelector } from 'src/utils/Hooks';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { Radio } from '@mui/material';
import { useStacklineTheme } from '@stackline/ui';
import { useDispatch } from 'react-redux';
import { setEntity } from 'src/store/modules/adManager/adBudgetEditor/actions';

const AddClickField = {
  name: AdvertisingMetric.AD_CLICK,
  displayName: 'Ad\nClicks'
};

const AdSpendField = {
  name: AdvertisingMetric.AD_SPEND,
  displayName: 'Ad\nSpend'
};

const AdSalesField = {
  name: AdvertisingMetric.AD_SALES,
  displayName: 'Ad\nSales'
};
const ROASField = {
  name: AdvertisingMetric.ROAS,
  displayName: 'ROAS'
};

const EntitySelectColumn = ({ entity }: { entity: any }) => {
  const theme = useStacklineTheme();
  const dispatch = useDispatch();
  const adEntities = useAppSelector((state) => state.adEntities);
  const adBudgetEditor = useAppSelector((state) => state.adBudgetEditor);
  const adEntity = adEntities.find((e) => e.id === entity.entityId);
  const handleEntitySelect = () => {
    dispatch(
      setEntity({
        ...adEntity,
        ...entity
      })
    );
  };

  return (
    <Radio
      checked={adBudgetEditor.entity?.entityId === entity.entityId}
      disableRipple
      disableTouchRipple
      onClick={handleEntitySelect}
      sx={{
        svg: {
          height: '15px',
          width: '15px'
        },
        '&, &.Mui-checked': {
          color: theme.colors.primary
        }
      }}
    />
  );
};

const EntitySelectColumnDefinition = {
  headerName: '',
  valueFormatter: (_, row) => {
    return <EntitySelectColumn entity={row.entity} />;
  }
};

const EntityNameColumnDefinition = {
  headerName: 'Entity',
  valueFormatter: (_, row) => {
    return <Text variant="body2">{row.name}</Text>;
  }
};

const EntityIdColumnDefinition = {
  headerName: 'Entity ID',
  valueFormatter: (_, row) => {
    return <Text variant="body2">{row.entity.entityId}</Text>;
  }
};

const EntityEditor = () => {
  return (
    <MetricListContainer
      iconList={[]}
      skeletonRows={20}
      renderGrid={(args) => <ProductGrid {...args} />}
      headColumnDefinition={[EntitySelectColumnDefinition, EntityNameColumnDefinition, EntityIdColumnDefinition]}
      entityTableHeaderProps={{
        prefixTitle: 'Ad Metric by',
        title: 'Entity select'
      }}
      indexName="adCampaignDailyMetrics"
      fields={[AddClickField, AdSpendField, AdSalesField, ROASField]}
      useTableDataProps={{
        buildRequest: (builder: AdvancedSearchRequestBuilder) => {
          return builder.removeConditionTermFilters((builderFilter) => builderFilter.fieldName === 'categoryId');
        },
        groupByFieldName: 'entityId',
        filterResponse: () => true
      }}
      sortFieldName="clicks"
      showGrid={false}
    />
  );
};

export default EntityEditor;
